// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__1OSHO","inputInnerContainer":"Input_inputInnerContainer__sTtrv","unitAbsolute":"Input_unitAbsolute__2+YOD"};